export const truncar2 = (n) => {
  if (n) {
    const twoDecimalString = `${n}`.match(new RegExp(`^-?\\d+(?:\.\\d{0,2})?`))[0];
    return Number(twoDecimalString).toFixed(2);
  } else {
    return;
  }
};

export const truncar = (n) => {
  if (n) {
    const twoDecimalString = `${n}`.match(new RegExp(`^-?\\d+(?:\.\\d{0,2})?`))[0];
    return Number(twoDecimalString).toFixed(2);
  } else {
    return;
  }
};

export const valorAPesos = (n) => {
  // const numeroAPesosMex = Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n);
  // const numeroAPesosArg =
  return Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(n);
};
export const valorADolares = (n) => {
  return Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    .formatToParts(n)
    .map((part) => {
      if (part.type === "currency") {
        // Colocar el símbolo de la moneda antes de la cantidad
        return "USD ";
      }
      return part.value;
    })
    .join("");
};

export const agregarCeros = (n, longitud) => {
  return n?.toString().padStart(longitud, "0");
};
